const validId = value => typeof value === 'string' && /^[A-Za-z0-9_-]{1,64}$/.test(value)
export const DEFAULT_COMPONENT_CATALOG = 'res_component_default'

// 只合并显示位置；服务端分类 ID 与内置组件的拖拽编号始终保留。
export function componentPaletteSections (baseSections, catalogs) {
  const sections = baseSections.map(section => ({ ...section, path: section.label, catalogIds: [], items: section.items.slice() }))
  const builtinNames = new Map(sections.map(section => [section.label, section]))
  const seen = new Set()
  const pending = (Array.isArray(catalogs) ? catalogs : []).map(catalog => ({ catalog, parents: [] })).reverse()
  while (pending.length) {
    const { catalog, parents } = pending.pop()
    if (!catalog || !validId(catalog.id) || typeof catalog.name !== 'string' || !catalog.name.trim() || seen.has(catalog.id)) continue
    seen.add(catalog.id)
    const name = catalog.name.trim(), names = [...parents, name], path = names.join(' / ')
    const isDefault = catalog.id === DEFAULT_COMPONENT_CATALOG, direct = !parents.length
    if (isDefault) {
      // 默认登记根不是可见类型；旧根内的自建组件仍从原ID读取，归入常用。
      let common = sections.find(section => section.id === 'common')
      if (!common) {
        common = { id: 'common', label: '常用', path: '常用', catalogIds: [], items: [], expanded: true }
        sections.unshift(common); builtinNames.set(common.label, common)
      }
      common.catalogIds.push(catalog.id)
    } else {
      const builtin = direct && builtinNames.get(name)
      if (builtin) builtin.catalogIds.push(catalog.id)
      else sections.push({ id: 'resource-' + catalog.id, label: direct ? name : path, path, catalogIds: [catalog.id], items: [], expanded: false })
    }
    if (Array.isArray(catalog.children)) {
      for (let index = catalog.children.length - 1; index >= 0; index--) pending.push({ catalog: catalog.children[index], parents: isDefault ? parents : names })
    }
  }
  return sections
}

export function componentPaletteItem (resource) {
  return { key: 'resource:' + resource.id, label: resource.name, resource }
}
